import { Box, Button, styled, Typography } from "@mui/material";
import React from "react";
import ReportsCard from "./reportsCard/ReportsCard";
import { Link } from "react-router-dom";


const MainBox = styled(Box)(({theme}) => ({
  width: "60%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  textAlign: "center",
  [theme.breakpoints.down('mdlg')]: {
    width: '90%',
    marginTop: 30,
  },
}))

const StyledTypography = styled(Typography)(({theme}) => ({
  fontSize: '1.8rem',
  marginTop: 0,
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.4rem',
  }
}))


function ReportsSection() {

    const ReportsData = [
        {
            Title: 'Ship Leasing Market Size to Hit USD 61.37 Billion by 2034',
            Info: 'The global ship leasing market size is accounted to hit around USD 61.37 billion by 2034 increasing from USD 14.49 billion in 2024, with a CAGR of 15.53%.',
        },
        {
            Title: 'Polytetrafluoroethylene Market Size to Hit USD 6.61 Billion by 2034',
            Info: 'The global polytetrafluoroethylene market size is accounted to hit around USD 6.61 billion by 2034 increasing from USD 3.85 billion in 2024, with a CAGR of 5.54%.',
        },
        {
            Title: 'Wood Coatings Market Size to Hit USD 19.45 Billion by 2034',
            Info: 'The global wood coatings market size is estimated to hit around USD 19.45 billion by 2034 increasing from USD 12.02 billion in 2024, with a CAGR of 4.93%.',
        },
        {
            Title: 'Optical Coherence Tomography Market Size to Hit USD 9.79 Billion by 2034',
            Info: 'The global optical coherence tomography market size is accounted to hit around USD 9.79 billion by 2034 increasing from USD 2.23 billion in 2024, with a CAGR of 1',
        },
    ];

  return (
    <MainBox>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }} >
        <StyledTypography fontWeight={600} >LATEST REPORTS</StyledTypography>
      </Box>
      <Box sx={{ width: '100%' }} >
        {ReportsData.map((items, index) => (
            <ReportsCard key={index} {...items} />
        ))}
      </Box>
      <Box sx={{ py: 2 }} >
        <Button variant="contained" sx={{ bgcolor: '#242424', height: '100%' }} ><Link to="/market_reports" style={{ textDecoration: 'none', color: 'white' }} >View More</Link></Button>
      </Box>
    </MainBox>
  );
}

export default ReportsSection;
